import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REDUX_SLICE_KEYS } from 'common/constants';
import type { DropdownOption, StoreSelectState } from './types';
import type { RootState } from 'store';

const initialState: StoreSelectState = {
  selectedStoreId: { label: '', value: '', 'data-testid': '' },
  noStoreAvailable: false,
  storeDropdownOptions: [],
  departmentName: ''
};

export const storeSlice = createSlice({
  name: REDUX_SLICE_KEYS.userStore,
  initialState,
  reducers: {
    setSelectedStoreOption: (state, action: PayloadAction<DropdownOption>) => {
      state.selectedStoreId = action.payload;
    },
    setNoStoreAvailable: (state, action: PayloadAction<boolean>) => {
      state.noStoreAvailable = action?.payload;
    },
    setStoreDropdownOptions: (
      state,
      action: PayloadAction<DropdownOption[]>
    ) => {
      state.storeDropdownOptions = action?.payload;
    },
    setDepartmantName: (state, action: PayloadAction<string>) => {
      state.departmentName = action.payload;
    }
  }
});

export const {
  setSelectedStoreOption,
  setNoStoreAvailable,
  setStoreDropdownOptions,
  setDepartmantName
} = storeSlice.actions;

const selectSelf = (state: RootState) => state;

export const getSelectedStoreOption = createSelector(
  selectSelf,
  ({ userStore }) => userStore.selectedStoreId
);

export const getCompanyId = createSelector(
  getSelectedStoreOption,
  ({ label }) => label?.split('-')[0]?.trim() || ''
);

export const getStoreId = createSelector(
  getSelectedStoreOption,
  ({ value }) => value
);

export const getNoStoreAvailable = createSelector(
  selectSelf,
  ({ userStore }) => userStore.noStoreAvailable
);

export const getDepartmentName = createSelector(
  selectSelf,
  ({ userStore }) => userStore.departmentName
);

export default storeSlice.reducer;
